module.exports = __webpack_public_path__ + "img/model-is-approved.c8b57c8a.png";